module.exports = __webpack_public_path__ + "img/1-1PF5192G6437.4d178b90.png";